import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Tooltip } from 'antd';
import _ from 'lodash';
import { formValueSelector } from 'redux-form';
import { attributeEquation as AttributeEquation } from 'theme/icon';
import styles from './styles.scss';

const EquationAttribute = props => (
  <div className={cn(styles.row, styles.equation)}>
    <div className={styles.header}>
      <div className={styles.icon}>
        <AttributeEquation alt="" />
      </div>
      <div className={styles.caption}>
        <Tooltip placement="bottomLeft" title={props.name.length > 25 ? props.name : null}>
          <h4>{_.truncate(props.name, { omission: '...', length: 25 })}</h4>
        </Tooltip>
      </div>
    </div>
    <div className={styles.body} style={{ textDecoration: 'none' }}>
      <p className={cn(styles.result, { [styles.resultError]: props.error })}>{props.result}</p>
      {props.error && <p className={styles.message}>{props.message}</p>}
    </div>
  </div>
);

EquationAttribute.propTypes = {
  name: PropTypes.string.isRequired,
  message: PropTypes.string,
  error: PropTypes.string,
  result: PropTypes.string,
};

EquationAttribute.defaultProps = {
  message: '',
  error: '',
  result: '',
};

const selector = formValueSelector('cardAttribute');

export default connect(state => ({
  attributes: selector(state, 'attributes'),
}))(EquationAttribute);
